module.exports = __webpack_public_path__ + "static/media/refresh.2761776f.svg";